export default __webpack_public_path__ + "static/media/Geography01_05.2cdfb198.png";